var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18254_243606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 23L12 20V42.167C12 42.6531 12.1931 43.1194 12.5369 43.4631C12.8806 43.8069 13.3469 44 13.833 44H43.167C43.6531 44 44.1194 43.8069 44.4631 43.4631C44.8069 43.1194 45 42.6531 45 42.167V34L29 23Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 4H13.833C13.3469 4 12.8806 4.19312 12.5369 4.53687C12.1931 4.88063 12 5.34686 12 5.833V14L29 24L38 27L45 24V14L29 4Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14H29V24H12V14Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.167 12H12V37H24.167C24.6527 36.9984 25.118 36.8048 25.4614 36.4614C25.8048 36.118 25.9984 35.6527 26 35.167V13.833C25.9984 13.3473 25.8048 12.882 25.4614 12.5386C25.118 12.1952 24.6527 12.0016 24.167 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.167 13H12V38H23.167C23.6527 37.9984 24.118 37.8048 24.4614 37.4614C24.8048 37.118 24.9984 36.6527 25 36.167V14.833C24.9984 14.3473 24.8048 13.882 24.4614 13.5386C24.118 13.1952 23.6527 13.0016 23.167 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.167 13H12V36H23.167C23.6527 35.9984 24.118 35.8048 24.4614 35.4614C24.8048 35.118 24.9984 34.6527 25 34.167V14.833C24.9984 14.3473 24.8048 13.882 24.4614 13.5386C24.118 13.1952 23.6527 13.0016 23.167 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.167 13H12V36H22.167C22.6527 35.9984 23.118 35.8048 23.4614 35.4614C23.8048 35.118 23.9984 34.6527 24 34.167V14.833C23.9984 14.3473 23.8048 13.882 23.4614 13.5386C23.118 13.1952 22.6527 13.0016 22.167 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.167 13H3.833C2.82066 13 2 13.8207 2 14.833V33.167C2 34.1793 2.82066 35 3.833 35H22.167C23.1793 35 24 34.1793 24 33.167V14.833C24 13.8207 23.1793 13 22.167 13Z",
    fill: "url(#paint0_linear_18254_243606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67676 29.958L11.5328 23.983L7.99976 18.041H10.8418L12.7698 21.841C12.9478 22.202 13.0698 22.47 13.1358 22.647H13.1608C13.2874 22.359 13.4208 22.0793 13.5608 21.808L15.6218 18.043H18.2308L14.6078 23.95L18.3228 29.958H15.5468L13.3198 25.787C13.2149 25.6095 13.1258 25.4232 13.0538 25.23H13.0208C12.9555 25.4192 12.869 25.6004 12.7628 25.77L10.4698 29.958H7.67676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.167 4H29V14H45V5.833C45 5.34686 44.8069 4.88063 44.4631 4.53687C44.1194 4.19312 43.6531 4 43.167 4Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 24H45V34H29V24Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18254_243606",
    x1: 5.822,
    y1: 11.568,
    x2: 20.178,
    y2: 36.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18254_243606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelLogo);
export default __webpack_public_path__ + "static/media/excel-logo.79c9167f29f9f8465695709c3b61eb3a.svg";
export { ForwardRef as ReactComponent };